(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[24],{

/***/ 6739:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/category/[slug]",
      function () {
        return __webpack_require__(6112);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Cta; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

function Cta(param) {
    var className = param.className, children = param.children, _skewBottom = param.skewBottom, skewBottom = _skewBottom === void 0 ? true : _skewBottom;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "section-cta",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: className,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "skew-top"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex flex-col items-center py-20",
                        children: children
                    })
                }),
                skewBottom && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "skew-bottom"
                })
            ]
        })
    });
}


/***/ }),

/***/ 5467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HeroSubpage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _photo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4761);


function HeroSubpage(props) {
    var ref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "header-subpage relative ".concat(props.headerCss ? props.headerCss : ""),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "relative subpage-gradient w-full",
                    children: ((ref = props.image) === null || ref === void 0 ? void 0 : ref.data) ? props.imageAsBackground ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "absolute z-1 top-0 w-full h-full opacity-50 bg-blend-soft-light bg-no-repeat bg-cover bg-center",
                                style: {
                                    backgroundImage: "url(".concat(props.image.data.attributes.url, ")")
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "container py-[12rem] relative z-2 ",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex items-center justify-start ",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "flex flex-col w-full p-10 md:w-2/3 text-white justify-start ".concat(props.contentCss ? props.contentCss : ""),
                                        dangerouslySetInnerHTML: {
                                            __html: props.content
                                        }
                                    })
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-center justify-start py-[10rem]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex w-2/5 mx-auto md:w-1/2 relative z-20 pl-8 justify-center",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_photo__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                        image: props.image
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex flex-col w-full p-8 pt-0 md:w-2/3 text-white justify-start",
                                    dangerouslySetInnerHTML: {
                                        __html: props.content
                                    }
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex items-center justify-start pt-[6rem] pb-[6rem]",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex flex-col w-full p-10 ".concat(!props.full ? "md:w-2/3" : "", " text-white justify-start"),
                                dangerouslySetInnerHTML: {
                                    __html: props.content
                                }
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "skew-bottom"
                })
            ]
        })
    });
}


/***/ }),

/***/ 604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PhotoGallery; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _photo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4761);
/* harmony import */ var fslightbox_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1129);
/* harmony import */ var fslightbox_react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(fslightbox_react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_global_context__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5439);
/* harmony import */ var _section_title__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5715);
/* harmony import */ var _lib_media__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6017);








function PhotoGallery(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), toggler = ref[0], setToggler = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1), slide = ref1[0], setSlide = ref1[1];
    var ref2 = (0,_lib_global_context__WEBPACK_IMPORTED_MODULE_5__/* .useGlobalContext */ .bN)(), state = ref2.state, dispatch = ref2.dispatch;
    var photos = props.photos.data.map(function(p) {
        return p.attributes.mime === "video/mp4" ? {
            type: "video",
            src: p.attributes.url,
            caption: p.attributes.caption,
            thumb: ""
        } : {
            type: "image",
            width: p.attributes.width,
            height: p.attributes.height,
            image: {
                data: p
            },
            src: p.attributes.url,
            thumb: p.attributes.formats.thumbnail.url,
            caption: p.attributes.caption
        };
    });
    var limit = props.visibleSlides || photos.length;
    var gallery = photos.slice(0, limit);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            (props.title || props.desciption) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_section_title__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                title: props.title,
                description: props.description,
                className: "w-full md:w-1/2"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "gallery relative ".concat(props.type ? props.type : "", " ").concat(props.className ? props.className : "", " ").concat(gallery.length === 1 ? "cols-1" : ""),
                children: gallery.map(function(p, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        "data-id": index,
                        className: "relative w-full aspect-[4/3]",
                        onClick: function() {
                            setSlide(index + 1);
                            setToggler(!toggler);
                        },
                        children: [
                            p.type === "image" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                src: (0,_lib_media__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(p.image),
                                alt: p.image.data.attributes.alternativeText || "",
                                layout: "fill",
                                priority: !index ? true : false,
                                quality: 85,
                                className: "object-cover"
                            }),
                            p.type === "video" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                                muted: false,
                                autoPlay: true,
                                playsInline: true,
                                src: p.src
                            }),
                            p.type === "video" && gallery.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                type: "button",
                                className: "absolute top-[calc(50%-2.5rem)] text-[5rem] left-[calc(50%-2.5rem)] text-white",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                    className: "flaticon-youtube"
                                })
                            })
                        ]
                    }, "slide-".concat(index));
                })
            }),
            gallery.length < photos.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "continue relative w-full h-full justify-center items-center flex",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    className: "btn maturity-border",
                    onClick: function() {
                        return setToggler(!toggler);
                    },
                    children: "View all photos"
                })
            }, "slide-last"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((fslightbox_react__WEBPACK_IMPORTED_MODULE_3___default()), {
                showThumbsOnMount: true,
                toggler: toggler,
                sources: photos.map(function(p) {
                    return p.src;
                }),
                types: photos.map(function(p) {
                    return p.type;
                }),
                thumbs: photos.map(function(p) {
                    return p.thumb;
                }),
                captions: photos.map(function(p) {
                    return p.caption;
                }),
                slide: slide,
                onOpen: function() {
                    return dispatch({
                        type: "GALLERY",
                        payload: true
                    });
                },
                onClose: function() {
                    return dispatch({
                        type: "GALLERY",
                        payload: false
                    });
                }
            })
        ]
    });
}


/***/ }),

/***/ 6112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./lib/seo-context.js
var seo_context = __webpack_require__(4449);
// EXTERNAL MODULE: ./components/photo.jsx
var photo = __webpack_require__(4761);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/layout.jsx + 5 modules
var layout = __webpack_require__(5726);
// EXTERNAL MODULE: ./components/hero-subpage.jsx
var hero_subpage = __webpack_require__(5467);
// EXTERNAL MODULE: ./components/cta.jsx
var cta = __webpack_require__(7693);
// EXTERNAL MODULE: ./lib/helper.js
var helper = __webpack_require__(4994);
// EXTERNAL MODULE: ./lib/global-context.js
var global_context = __webpack_require__(5439);
// EXTERNAL MODULE: ./components/section-title.jsx
var section_title = __webpack_require__(5715);
;// CONCATENATED MODULE: ./components/content-block.jsx



function ContentBlock(param) {
    var settings = param.settings;
    settings.type = "hero";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            settings.type === "text-block" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(section_title/* default */.Z, {
                            title: settings.title,
                            style: "text-trust",
                            className: "mt-10"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container content",
                            dangerouslySetInnerHTML: {
                                __html: settings.content
                            }
                        })
                    })
                ]
            }, "content-" + settings.id),
            settings.type == "hero" && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "bg-maturity-50 bg-opacity-50 relative pt-24 pb-8 text-justify text-md",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "skew-top"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col p-20",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-trust-900 text-3xl normal-case py-8 text-justify text-md",
                                        dangerouslySetInnerHTML: {
                                            __html: settings.title
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: " pb-10 text-justify text-md",
                                        dangerouslySetInnerHTML: {
                                            __html: settings.content
                                        }
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "skew-bottom"
                        })
                    ]
                })
            }, "content-" + settings.id)
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/content-box.jsx





function ContentBox(param) {
    var settings = param.settings;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "content-box mx-4 bg-white max-w-screen-lg bg-opacity-20 my-20 lg:mx-auto rounded-[0.25rem] border-[1px] border-maturity-100 shadow-lg overflow-hidden",
            children: [
                settings.photo.data && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col lg:flex-row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex w-full h-96 lg:h-auto lg:w-1/2 relative",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: settings.photo.data.attributes.url,
                                alt: settings.photo.data.attributes.alternativeText,
                                layout: "fill",
                                className: "object-cover"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col text-center w-full lg:w-1/2 lg:text-justify p-10 md:p-20 ",
                            children: [
                                settings.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "text-trust-500 text-2xl mb-4",
                                    children: settings.title
                                }),
                                settings.content && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    dangerouslySetInnerHTML: {
                                        __html: settings.content
                                    }
                                }),
                                settings.buttons && settings.buttons.map(function(button) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: button.link,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            title: button.label,
                                            className: "btn mt-4 btn-lg ".concat(button.style),
                                            children: button.label
                                        })
                                    }, "content-box-button-".concat(button.id));
                                })
                            ]
                        })
                    ]
                }),
                !settings.photo.data && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        settings.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "text-trust-500 text-2xl ",
                            children: settings.title
                        }),
                        settings.content && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            dangerouslySetInnerHTML: {
                                __html: settings.content
                            }
                        }),
                        settings.buttons && settings.buttons.map(function(button) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: button.link,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    title: button.label,
                                    className: "btn mt-4 btn-lg ".concat(button.style),
                                    children: button.label
                                })
                            }, "content-box-button-".concat(button.id));
                        })
                    ]
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./components/features.jsx + 11 modules
var features = __webpack_require__(5997);
// EXTERNAL MODULE: ./components/photo-gallery.jsx
var photo_gallery = __webpack_require__(604);
;// CONCATENATED MODULE: ./pages/category/[slug].jsx















var Category = function(props) {
    // const { state } = useGlobalContext();
    var pageProps = props.pageProps, global = props.global;
    if (!pageProps) {
        return "";
    }
    var seo = (0,helper/* Merge */.$U)(global.seo, pageProps.seo);
    seo.canonicalURL = "".concat("https://www.arka-parcel-lockers.com", "/category/").concat(pageProps.slug);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(seo_context/* default.Provider */.Z.Provider, {
        value: seo,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* default */.Z, {
            footerClass: "skew-maturity-100",
            languageData: {
                originalSlug: pageProps.originalSlug,
                languages: pageProps.localizations
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(hero_subpage/* default */.Z, {
                    image: pageProps.boxPhoto,
                    content: "<h1>".concat(pageProps.title, "</h1>") + pageProps.description
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "grid grid-cols-1 m-10 mt-32 md:grid-cols-2 lg:grid-cols-3 gap-20",
                                children: pageProps.products.data.map(function(entry) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "rounded-[0.25rem] shadow-lg border-[1px] border-maturity p-8 pt-0 bg-white",
                                        children: [
                                            entry.attributes.cover.data && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "h-[22rem] relative -mt-10 z-30 text-center flex items-center justify-center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(photo/* default */.Z, {
                                                    layout: "fill",
                                                    objectFit: "contain",
                                                    image: entry.attributes.cover
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                className: "text-action mt-4 block uppercase",
                                                children: entry.attributes.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "block my-4 ",
                                                dangerouslySetInnerHTML: {
                                                    __html: entry.attributes.listDescription ? entry.attributes.listDescription : entry.attributes.description
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/products/".concat(entry.attributes.slug),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "btn action-border",
                                                    children: entry.attributes.title
                                                })
                                            })
                                        ]
                                    }, entry.id.toString());
                                })
                            }),
                            pageProps.sections.map(function(section) {
                                switch(section.__component){
                                    case "layout.feature-list":
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(features/* default */.Z, (0,_object_spread/* default */.Z)({}, section), "feat-".concat(section.id));
                                    case "layout.content-block":
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentBlock, {
                                            settings: section
                                        }, "content-block-" + section.id);
                                    case "layout.content-box":
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentBox, {
                                            settings: section
                                        }, "content-box-" + section.id);
                                    case "layout.gallery":
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(photo_gallery/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, section), {
                                            className: "px-10"
                                        }), "gallery-".concat(section.id));
                                }
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(cta/* default */.Z, {
                    skewBottom: false,
                    className: "bg-maturity-100 relative pt-24 pb-8 text-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-trust-900 text-3xl normal-case py-8 w-2/3 mx-auto font-semibold",
                            children: "Do you want to know more about our products?"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/contact",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "btn action-full !text-base !px-10 !py-4",
                                children: "Let's get in touch"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (Category);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [660,396,535,489,726,793,774,888,179], function() { return __webpack_exec__(6739); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);